// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Q6+Ll","info":"Contact_info__a9nMr","form":"Contact_form__u7HXY"};